import { render } from "./TheFaq.vue?vue&type=template&id=208a538e&scoped=true&ts=true&lang=html"
import script from "./TheFaq.vue?vue&type=script&lang=ts"
export * from "./TheFaq.vue?vue&type=script&lang=ts"

import "./TheFaq.vue?vue&type=style&index=0&id=208a538e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208a538e"]])

export default __exports__